module.exports = __webpack_public_path__ + "img/main.f6e6c8a3.png";